import { memo, useState } from "react";
import Image from "next/image";
import DiscordImageUrl from "./assets/discord.png";
import { Audience } from "../../../model/info-about-bootcamp";

interface Props {
  data: Audience;
}

export const DiscordInfo = memo<Props>(({ data }) => {
  const [visabilityModal, setVisabilityModal] = useState<
    Record<number, boolean>
  >({
    0: true,
  });

  function handleClick(index: number) {
    setVisabilityModal((prev) => ({
      [index]: !prev[index],
    }));
  }

  return (
    <div className="lg:grid grid-cols-2 gap-[20px] bg-white pb-36 lg:pb-60">
      <div className="rounded-[16px]">
        <Image
          src={DiscordImageUrl}
          alt="Discord image"
          className="h-full rounded-[16px] w-full object-cover pb-6 lg:pb-0"
        />
      </div>
      <div className="rounded-[22px] bg-day-base-base-100 pt-20 pl-4 pr-4 pb-4 lg:p-20">
        <div
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{
            __html: data.title,
          }}
          className="m-auto max-w-[360px] lg:max-w-full text-center lg:text-left mb-12 lg:mb-16 text-[28px] leading-[110%] lg:text-[36px] lg:leading-[36px]"
        />
        {data.list.map((item, index) => (
          <div
            key={index}
            className="cursor-pointer flex mt-5 rounded-[22px] bg-day-base-base-200 p-6 lg:p-10"
            onClick={() => handleClick(index)}
          >
            <div className="mr-6 h-max rounded-[9px] bg-day-base-base-800 pl-6 pr-6 lg:pl-9 lg:pr-9 h-[28px] lg:h-[34px] text-white">
              <span className="text-[14px] leading-[100%] relative top-[-1px] lg:top-[2px]">
                0{index + 1}
              </span>
            </div>
            <div>
              <div
                // eslint-disable-next-line
                dangerouslySetInnerHTML={{
                  __html: item.title,
                }}
                className="text-[16px] leading-[130%] lg:text-[20px] lg:leading-[124%] relative top-[4px]"
              />
              {item.description && (
                <div
                  className={
                    visabilityModal[index]
                      ? "pt-4 text-[15px] leading-[20px] lg:text-[18px] lg:leading-[132%] text-day-base-base-400"
                      : "hidden"
                  }
                  // eslint-disable-next-line
                  dangerouslySetInnerHTML={{
                    __html: item.description,
                  }}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});
